import React from "react";

import { InputNumericValueSlider } from "./InputNumericValueSlider";
import { InputNumericValueSelect } from "./InputNumericValueSelect";

export interface IInputNumericValue {
  value: number;
  min: number;
  max: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  unit?: string;
  hideEdges?: boolean;
  disabled?: boolean;
  disabledInput?: boolean;
  onChangeHandler: any;
  variant?: "slider" | "select";
}
const InputNumericValue: React.FC<IInputNumericValue> = ({
  value = 20,
  min = 0,
  max = 100,
  step,
  hideEdges = false,
  disabled = false,
  disabledInput = false,
  onChangeHandler = (e: any) => console.log(e),
  variant = "slider",
  prefix,
  suffix,
  unit,
}) => {
  let Component;

  switch (variant) {
    case "select":
      Component = InputNumericValueSelect;
      break;
    default:
      Component = InputNumericValueSlider;
      break;
  }

  return (
    <Component
      {...{
        value,
        min,
        max,
        hideEdges,
        disabled,
        disabledInput,
        step,
        unit,
        prefix,
        suffix,
        onChangeHandler,
      }}
      data-testid="input-numeric-value-slider"
    />
  );
};

export default InputNumericValue;
